var map = {
	"./attack-flat.svg": "5df4",
	"./attack-heel.svg": "cca5",
	"./attack-toe.svg": "3493",
	"./flat-foot.svg": "c4d6",
	"./heel-off-shoe.svg": "44d0",
	"./heel-strike-shoe.svg": "9115",
	"./heel-strike.svg": "8673",
	"./little-symmetry-error.svg": "36f4",
	"./little-symmetry-neutral.svg": "dcc3",
	"./little-symmetry-success.svg": "13ee",
	"./little-symmetry-warning.svg": "fc065",
	"./patho-F.svg": "9dd7",
	"./patho-H.svg": "97d3",
	"./patho-unknown-F.svg": "1987",
	"./patho-unknown-H.svg": "51cd",
	"./propulsion.svg": "99d7",
	"./run-decomposition.svg": "1725",
	"./single-shoe.svg": "e679",
	"./symmetry-error.svg": "e35e",
	"./symmetry-ok.svg": "7e9a",
	"./symmetry-success.svg": "3617",
	"./symmetry-warning.svg": "9306",
	"./toe-off-shoe.svg": "9cf5",
	"./toe-strike-shoe.svg": "4098",
	"./walking-phase.svg": "f4a7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";